import { Button } from "@netfront/ui-library";
import { Card } from "../Card"

export const GoalsCard = () => {
  return(
    <Card additionalClassNames="grid md:grid-cols-[auto_1fr] border-green-400 gap-4 items-start shadow-none c-spotlight--goals">
      <img className="w-18" src="/images/goal-icon.svg" alt="Goals" />
      <div className="flex flex-col items-start h-full">
        <p className="h3 mb-1">Goals</p>
        <p className="mb-4">View your most recent goals</p>
        
        <Button
          additionalClassNames="mt-auto"
          linkButton={{ id: 'goals', url: '/goals' }}
          variant="tertiary"
          text="View goals"
        />
      </div>
    </Card>
  )
};